import forgotCredentialsModule from "../forgotCredentialsModule.js";

function verifyCodeController($scope, $uibModalInstance, numericCodeService, httpService, urlService, forgotCredentialsService, forgotCredentialsConstants, captchaV2Constants, phoneConstants, languageResource) {
    "ngInject";
    $scope.layout = {
        isVerifyCodeBusy: false
    };

    $scope.captchaActionTypes = captchaV2Constants.captchaActionTypes;
    $scope.captcha = forgotCredentialsService.captcha;

    $scope.init = function () {
        if ($scope.verifyCodeData.transmissionType === forgotCredentialsConstants.transmissionTypes.email) {
            $scope.layout.showEmailImage = true;
            $scope.layout.title = languageResource.get("Heading.VerifyCode");
            $scope.layout.message = languageResource.get("Message.EnterCodeSentToEmail");
        } else {
            $scope.layout.title = languageResource.get("Heading.VerifyPhone");
            $scope.layout.message = languageResource.get("Message.EnterCode");
        }
    }

    $scope.clearCodeError = function () {
        $scope.layout.codeError = null;
    }

    $scope.submitCode = function () {
        if (!$scope.verifyCodeData.code) {
            return;
        }

        $scope.layout.isVerifyCodeBusy = true;
        $scope.clearCodeError();
        var code = $scope.verifyCodeData.code;
        var nonce = $scope.verifyCodeData.nonce;

        if (!numericCodeService.checkCode(code, $scope.verifyCodeData.codeLength)) {
            $scope.layout.codeError = languageResource.get("Placeholder.EnterCode", { codeLength: $scope.verifyCodeData.codeLength });
            $scope.layout.isVerifyCodeBusy = false;
        }
        else {
            forgotCredentialsService.verifyCode(nonce, code)
                .then(function success(result) {
                    if (result.userTickets && result.userTickets.length > 0) {
                        $uibModalInstance.close(result.userTickets[0]);
                    } else {
                        $scope.layout.codeError = result.message;
                    }
                }, function (result) {
                    if (result && result.errors && result.errors.length > 0) {
                        $scope.layout.codeError = result.errors[0].message;
                    } else {
                        $scope.layout.codeError = languageResource.get("Message.DefaultError");
                    }
                }).finally(function () {
                    $scope.layout.isVerifyCodeBusy = false;
                });
        }
    }

    $scope.resendCode = function (captchaData) {
        $scope.layout.isVerifyCodeBusy = true;
        $scope.clearCodeError();

        forgotCredentialsService.sendResetPasswordForPhone($scope.verifyCodeData.phonePrefix, $scope.verifyCodeData.phone, $scope.verifyCodeData.countryCode, captchaData)
            .then(function success(result) {
                if (result.nonce) {
                    // TODO: show some kind of feedback
                    $scope.verifyCodeData.nonce = result.nonce;
                    $scope.verifyCodeData.transmissionType = result.transmissionType; 
                } else {
                    $scope.layout.codeError = result.message;
                }
            }, function (error) {
                var errorCode = httpService.getPrimaryApiErrorCode(error);
                if (errorCode === forgotCredentialsConstants.passwordErrorCodes.captcha) {
                    $scope.captcha.isActivated = true;
                    $scope.captcha.captchaPassed = function (captchaData) { $scope.resendCode(captchaData); };
                    $scope.captcha.captchaFailed = function () { $scope.layout.codeError = languageResource.get("Message.DefaultError"); };
                    return;
                }

                $scope.layout.codeError = languageResource.get("Message.DefaultError");
            }).finally(function () {
                $scope.layout.isVerifyCodeBusy = false;
            });
    }

    $scope.init();
}

forgotCredentialsModule
    .controller("verifyCodeController", verifyCodeController);

export default verifyCodeController;
